import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { EditExclusionPanelWrapper } from '../../../components/application-exclusions/edit-exclusion-panel'

export interface BridgeProps {
  organizationUuid: string
  applicationId: string
  exclusionId: string
  isRaspEnabled: boolean
}

export function Bridge({
  organizationUuid,
  applicationId,
  exclusionId,
  isRaspEnabled
}: BridgeProps) {
  if (!organizationUuid || !applicationId || !exclusionId) {
    return <></>
  }

  return (
    <EditExclusionPanelWrapper
      organizationUuid={organizationUuid}
      applicationId={applicationId}
      exclusionId={exclusionId}
      isRASPEnabled={isRaspEnabled}
    />
  )
}

export const reactEditExclusionPanel = createNgReactBridgeDirective(
  'reactEditExclusionPanel',
  [],
  Bridge,
  ['organizationUuid', 'applicationId', 'exclusionId', 'isRaspEnabled']
)
